export class FormsDirtyChecker extends HTMLElement {
    set isDirty(value: string) {
        this.dataset.isDirty = value;
    }

    get isDirty() {
        return this.dataset.isDirty;
    }
}

customElements.define("c-forms-dirty-checker", FormsDirtyChecker);
declare global {
    interface HTMLElementTagNameMap {
        "c-forms-dirty-checker": FormsDirtyChecker;
    }
}
